// ── LoyaltyDebug — shared toggle + logger ────────────────────────────────────
(function () {
  // Sync URL param to localStorage on first load
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has('loyalty_debug')) {
      const val = params.get('loyalty_debug');
      if (val === '0') {
        localStorage.removeItem('loyalty_debug');
      } else {
        localStorage.setItem('loyalty_debug', val || '1');
      }
      params.delete('loyalty_debug');
      const newSearch = params.toString();
      history.replaceState(null, '', window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash);
    }
  } catch (_) {}

  const redact = {
    email(e) {
      if (!e || typeof e !== 'string') return e;
      const [local, domain] = e.split('@');
      return local ? local[0] + '***@' + (domain || '?') : e;
    },
    token(t) {
      if (!t || typeof t !== 'string') return t;
      return t.slice(0, 7) + '…' + t.slice(-4);
    },
    sig(s) {
      if (!s || typeof s !== 'string') return s;
      return s.slice(0, 8) + '…';
    },
  };

  function getLevel() {
    try { return localStorage.getItem('loyalty_debug') || '0'; } catch (_) { return '0'; }
  }

  function isOn() { const l = getLevel(); return l === '1' || l === 'verbose'; }
  function isVerbose() { return getLevel() === 'verbose'; }

  window.LoyaltyDebug = {
    enable()  { try { localStorage.setItem('loyalty_debug', '1'); } catch (_) {} console.info('[LoyaltyDebug] enabled'); },
    verbose() { try { localStorage.setItem('loyalty_debug', 'verbose'); } catch (_) {} console.info('[LoyaltyDebug] verbose'); },
    disable() { try { localStorage.removeItem('loyalty_debug'); } catch (_) {} console.info('[LoyaltyDebug] disabled'); },
    status()  { const l = getLevel(); console.info('[LoyaltyDebug] status:', l === '0' ? 'off' : l); return l; },
    isVerbose,
    redact,
  };

  window.__createLoyaltyLogger = function (prefix) {
    return {
      debug(...a) { if (isOn()) console.debug(prefix, ...a); },
      info(...a)  { if (isOn()) console.info(prefix, ...a); },
      warn(...a)  { if (isOn()) console.warn(prefix, ...a); },
      error(...a) { console.error(prefix, ...a); },
      group(label, fn) {
        if (!isOn()) { fn(); return; }
        console.group(prefix + ' ' + label);
        try { fn(); } finally { console.groupEnd(); }
      },
      time(l)    { if (isOn()) console.time(prefix + ' ' + l); },
      timeEnd(l) { if (isOn()) console.timeEnd(prefix + ' ' + l); },
      isVerbose,
    };
  };
})();

// ── Config ────────────────────────────────────────────────────────────────────
const YOUR_SERVER = "https://loyality.parisbleu.com/api";

// ── Main ──────────────────────────────────────────────────────────────────────
(async function () {
  const _pfx = '[ShopifyAuth]';
  const log = {
    debug: (...a) => console.debug(_pfx, ...a),
    info:  (...a) => console.info(_pfx, ...a),
    warn:  (...a) => console.warn(_pfx, ...a),
    error: (...a) => console.error(_pfx, ...a),
    group(label, fn) { console.group(_pfx + ' ' + label); try { fn(); } finally { console.groupEnd(); } },
    time:    (l) => console.time(_pfx + ' ' + l),
    timeEnd: (l) => console.timeEnd(_pfx + ' ' + l),
    isVerbose: () => window.LoyaltyDebug ? window.LoyaltyDebug.isVerbose() : false,
  };

  log.info('boot — debug level:', window.LoyaltyDebug ? window.LoyaltyDebug.status() : 'n/a');

  // ── CHECK 1: Is a customer logged in? ────────────────────────────────────
  const customer = window.__shopifyCustomer;

  if (!customer) {
    log.info('no customer on page — exit');
    return;
  }

  log.group('customer detected', () => {
    const d = window.LoyaltyDebug;
    log.info('id:', customer.id);
    log.info('email:', d.isVerbose() ? customer.email : d.redact.email(customer.email));
    log.info('ts:', customer.ts, '→ age', Math.round(Date.now() / 1000 - customer.ts) + 's');
    log.info('sig:', d.isVerbose ? customer.sig : d.redact.sig(customer.sig));
  });

  // ── CHECK 2: Do we already have a valid app token for THIS customer? ────────
  const existingToken = sessionStorage.getItem("app_token");
  const storedEmail   = sessionStorage.getItem("app_token_email");

  log.group('sessionStorage state', () => {
    log.info('app_token present:', !!existingToken);
    log.info('app_token_email:', storedEmail ? window.LoyaltyDebug.redact.email(storedEmail) : '(none)');
  });

  if (existingToken && storedEmail === customer.email) {
    log.info('token cache HIT — same customer, skipping request');
    log.info('dispatching loyaltyTokenReady from cache');
    window.dispatchEvent(new CustomEvent("loyaltyTokenReady", { detail: { token: existingToken } }));
    return;
  }

  if (existingToken && storedEmail !== customer.email) {
    log.warn('token cache MISMATCH — stored email differs, clearing', {
      stored: window.LoyaltyDebug.redact.email(storedEmail),
      current: window.LoyaltyDebug.redact.email(customer.email),
    });
    sessionStorage.removeItem("app_token");
    sessionStorage.removeItem("app_token_email");
  } else {
    log.info('token cache MISS — no token in sessionStorage');
  }

  // ── STEP: Request token from our server ──────────────────────────────────
  try {
    log.info('requesting app token from server…');
    const token = await requestAppToken(customer, log);
    sessionStorage.setItem("app_token", token);
    sessionStorage.setItem("app_token_email", customer.email);
    log.info('token stored in sessionStorage ✓');
    log.info('dispatching loyaltyTokenReady');
    window.dispatchEvent(new CustomEvent("loyaltyTokenReady", { detail: { token } }));
  } catch (err) {
    log.error('failed to get app token:', err.name + ':', err.message);
  }
})();

// ── HELPER: Request app JWT from our server ───────────────────────────────────
async function requestAppToken(customer, log) {
  const d = window.LoyaltyDebug;
  const url = `${YOUR_SERVER}/shopify-customer/auth/token`;

  log.group('fetch /auth/token', () => {
    log.info('url:', url);
    log.info('payload:', {
      customerId: String(customer.id),
      email: d.isVerbose() ? customer.email : d.redact.email(customer.email),
      ts: customer.ts,
      sig: d.isVerbose() ? customer.sig : d.redact.sig(customer.sig),
    });
  });

  log.time('fetch /auth/token');

  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: String(customer.id),
        email: customer.email,
        ts: customer.ts,
        sig: customer.sig,
      }),
    });
    log.timeEnd('fetch /auth/token');
    log.info('server responded HTTP', response.status);
  } catch (networkErr) {
    log.timeEnd('fetch /auth/token');
    log.error('network error reaching server:', networkErr.name + ':', networkErr.message);
    throw new Error("Network error: could not reach NestJS server");
  }

  if (!response.ok) {
    let errorBody;
    try {
      errorBody = await response.json();
    } catch {
      errorBody = await response.text();
    }
    log.error('server error (' + response.status + '):', errorBody);
    throw new Error(`Server returned HTTP ${response.status}`);
  }

  const json = await response.json();

  log.group('server response', () => {
    log.info('keys:', Object.keys(json));
    if (json.accessToken) {
      log.info('accessToken:', d.isVerbose() ? json.accessToken : d.redact.token(json.accessToken));
    }
  });

  if (!json.accessToken) {
    log.error('"accessToken" missing from server response');
    throw new Error("Server response did not include an accessToken");
  }

  return json.accessToken;
}
